module.exports = __webpack_public_path__ + "static/img/beta_bg_white_01.ba415c48.svg";